export default {
  authorization: state => state.authorization ? state.authorization : window.sessionStorage.getItem('authorization')
}



// WEBPACK FOOTER //
// ./src/store/getters.js